import { isBooleanTrue } from './objectUtils';

export const shouldUseRepDashboard = (authContext = {}) => {
	return isBooleanTrue(authContext?.isRep)
		&& !isBooleanTrue(authContext?.isAdmin)
		&& !isBooleanTrue(authContext?.isSuperAdmin)
		&& !isBooleanTrue(authContext?.isHelpStaff)
		&& !isBooleanTrue(authContext?.isStaffManager)
		&& !isBooleanTrue(authContext?.isMarketingManager)
		&& !isBooleanTrue(authContext?.isOwner);
};

export const getStaffDashboardLabel = (authContext = {}) => {
	return shouldUseRepDashboard(authContext) ? 'Rep Dashboard' : 'Admin Dashboard';
};
